import axios from 'axios';
import { ITwilioModel } from 'entities/Twilio/Twilio.models';

const basePath = 'calls/token';

export const twilioTransport = {
  getTwilioModel: (): Promise<ITwilioModel> => axios.post(`${basePath}`),
};
